import { CentraJS } from "@frend-digital/centra-js-client";
import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";

export type CountryVariables = {
  country: string;
  state?: string;
};

const updateCountry = async <FormattedSelection>({
  apiUrl,
  token,
  formatter,
  variables,
}: {
  variables: CountryVariables;
  token: string;
  apiUrl: string;
  formatter: (selection: BaseSelectionResponse) => FormattedSelection;
}) => {
  CentraJS.suspend();

  const path = variables.state 
    ? `countries/${variables.country}/states/${variables.state}` 
    : `countries/${variables.country}`

  const res = await fetch(`${apiUrl}/${path}`, {
    headers: {
      "API-token": token || "",
      "Content-Type": "application/json",
    },
    method: "PUT",
  });

  CentraJS.resume();

  if (!res.ok) throw Error("Error updating user");
  const response = await res.json();
  return formatter(response);
};

export default updateCountry;
